import { render, staticRenderFns } from "./exercisesMC.vue?vue&type=template&id=e7ca893c&scoped=true"
import script from "./exercisesMC.vue?vue&type=script&lang=js"
export * from "./exercisesMC.vue?vue&type=script&lang=js"
import style0 from "./exercisesMC.vue?vue&type=style&index=0&id=e7ca893c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ca893c",
  null
  
)

export default component.exports